import { API_BEACON_RECEIVE_ENDPOINT_V1 } from 'utils/constants';
import { request } from '../http';
import { BeaconEvent } from './types';

export async function sendEvent(event: BeaconEvent): Promise<void> {
  await request.post(API_BEACON_RECEIVE_ENDPOINT_V1, event);
  return undefined;
}
